export default __webpack_public_path__ + "images/f77372a2-report.svg";